import { Comment } from '@arpeggi/shared'
import { Box, Editor, EditorReadOnly, editorStateFromRaw, LineClampOptions } from '@arpeggi/ui'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { profilePath } from '../../profile'
import { Comments } from '../primitives'

interface Props {
  comment: Comment
  lineClamp?: LineClampOptions
}

export const CommentCard: FC<Props> = ({ comment, lineClamp }) => {
  return (
    <Comments.CommentCardContainer>
      <Link to={profilePath(comment.user)}>
        <Comments.Avatar src={comment.user.profilePicture?.url} />
      </Link>
      <Box>
        <Link to={profilePath(comment.user)}>
          <Comments.CommentCardDisplayName>
            {comment.user.displayName}
          </Comments.CommentCardDisplayName>
        </Link>
        <Editor value={editorStateFromRaw(comment.body)}>
          <EditorReadOnly lineClamp={lineClamp} />
        </Editor>
      </Box>
    </Comments.CommentCardContainer>
  )
}
